import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 开通BI
export function addBI(data) {
  return request({
    url: URL.external.biConfig.add,
    method: 'post',
    data
  })
}

// 编辑BI
export function editBI(data) {
  return request({
    url: URL.external.biConfig.edit,
    method: 'put',
    data
  })
}

// 获取租户列表
export function getAll(params) {
  return request({
    url: URL.external.biConfig.getAll,
    method: 'get',
    params
  })
}

// 复制仪表盘或图表到租户
export function copy(data) {
  return request({
    url: URL.external.biConfig.copy,
    method: 'post',
    data
  })
}

